import Image from '../../../components/image/Image';
import { pluralize } from '../../../utils';
import styles from './organization-cta-card.module.less';
import { Heading3 } from '@sb1/ffe-core-react';

const OrganizationCtaCard = ({
    className = '',
    banner,
    projectCount,
    title,
    description,
    children,
    customLink,
    shortenTexts = false,
}) => {
    return (
        <article className={[styles.ctaCard, className].join(' ')}>
            <div className={styles.ctaCardImage}>
                {banner && <Image src={banner} alt="Illustrasjon for aksjonen" />}
            </div>
            <div className={styles.ctaCardContent}>
                {customLink ? (
                    <div className={styles.numberOfProjects}>
                        <i className={['fas fa-heart', styles.numberOfProjectsIcon].join(' ')} />
                        Artikkel
                    </div>
                ) : (
                    projectCount >= 0 && (
                        <div className={styles.numberOfProjects}>
                            <i className={['fas fa-heart', styles.numberOfProjectsIcon].join(' ')} />
                            {projectCount} {pluralize(projectCount, 'innsamling', 'innsamlinger')}
                        </div>
                    )
                )}

                <Heading3
                    lookLike={4}
                    className={[styles.ctaCardTitle, ...(shortenTexts ? [styles.shortenTitle] : [])].join(' ')}
                >
                    {title}
                </Heading3>
                {description && (
                    <p
                        className={[
                            styles.ctaCardDescription,
                            ...(shortenTexts ? [styles.shortenDescription] : []),
                        ].join(' ')}
                    >
                        {description}
                    </p>
                )}

                <div className={styles.children}>{children}</div>
            </div>
        </article>
    );
};

export default OrganizationCtaCard;
